import { Typography } from 'antd';
import dayjs from 'dayjs';

import type { FactImplTableRow } from '@app/pages/Analytics/ActualImplementation/types';

import type { ColumnsType } from 'antd/es/table';

const { Text } = Typography;

export const COLUMNS: ColumnsType<FactImplTableRow> = [
  {
    title: 'Дата',
    dataIndex: 'Date',
    key: 'date',
    render: (_, row) => (
      <Text strong={row.isTotal}>
        {row.isTotal ? 'Итого' : dayjs(row.Date).format('DD.MM.YYYY')}
      </Text>
    ),
  },
  {
    title: 'Наличные',
    dataIndex: 'AmountCash',
    key: 'amountCash',
    align: 'right',
    render: (value: number, row) => (
      <Text strong={row.isTotal}>{value.toLocaleString('ru-RU')}</Text>
    ),
  },
  {
    title: 'Карта',
    dataIndex: 'AmountCard',
    key: 'amountCard',
    align: 'right',
    render: (value: number, row) => (
      <Text strong={row.isTotal}>{value.toLocaleString('ru-RU')}</Text>
    ),
  },
  {
    title: 'Списания с баланса',
    dataIndex: 'AmountFromBalance',
    key: 'amountFromBalance',
    width: 180,
    align: 'right',
    render: (value: number, row) => (
      <Text strong={row.isTotal}>{value.toLocaleString('ru-RU')}</Text>
    ),
  },
  {
    title: 'Итого',
    dataIndex: 'Total',
    key: 'total',
    align: 'right',
    render: (value: number, row) => (
      <Text strong={row.isTotal}>{value.toLocaleString('ru-RU')}</Text>
    ),
  },
];
